import { Stack, ContentCard, Grid, Button, Group } from '@forwardflow/ui-v2'
import { ArrowLeftMdIcon, BoltIcon, ChevronRightIcon } from '@forwardflow/icons'
import { motion } from 'framer-motion'
import {
   useOnboardingStoreV2,
} from '@forwardflow/store/onboardingStoreV2'
import { StageMapGroup } from './stage-mapping/StageMapGroup'

export const StageMappingNurtureLeads = () => {
   const { getNextStep, getPreviousStep, getTempStagesByGroupId } =
      useOnboardingStoreV2()

   const handleNextStep = () => {
      getNextStep()
   }

   return (
      <Stack gap={32}>
         <ContentCard
            className="space-y-2 !p-6"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
         >
            <Group>
               <Group className="p-2 px-2.5 rounded-[16.2px] border-[0.9px] border-[#8E51FF]/30 bg-gradient-to-br from-[#4F39F6]/30 to-[#7F22FE]/30">
                  <BoltIcon width={24} color="#9F7BFF" />
               </Group>
               <Stack gap={4}>
                  <p className="text-white font-medium">
                     Where do you place leads that are being nurtured?
                  </p>
                  <p className="text-[#99A1AF] text-sm font-medium max-w-[600px]">
                     Tell Forward Flow which stages or tags represent leads
                     still in your pipeline For example: If a lead says they're
                     3-6 months from buying, you might move them to “Hot
                     Prospect.” We'll use these to run smart follow-up and
                     check-in campaigns.
                  </p>
               </Stack>
            </Group>
         </ContentCard>
         <StageMapGroup
            title="Nurture Stages"
            groupId="ff-nurturing"
            shouldAddDescription
            allowAddStage
         />

         <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.6 }}
         >
            <Grid>
               <Grid.Col span={3}>
                  <Button
                     variant="secondary"
                     className="w-full"
                     onClick={() => getPreviousStep()}
                  >
                     <ArrowLeftMdIcon width={12} /> Back
                  </Button>
               </Grid.Col>
               <Grid.Col span={9}>
                  <Button
                     className="w-full"
                     onClick={() => handleNextStep()}
                     disabled={
                        !getTempStagesByGroupId('ff-nurturing').every((stage) =>
                           stage.type === 'tag'
                              ? !!stage.name
                              : stage.type === 'stage'
                                 ? !!stage.id && !!stage.name
                                 : false
                        )
                     }
                  >
                     Continue <ChevronRightIcon width={18} />
                  </Button>
               </Grid.Col>
            </Grid>
         </motion.div>
      </Stack>
   )
}
